export default {
  // 标题
  title: "提示",

  // 提示信息
  trialExpiredMessage:
    "尊敬的用户您好，您的试用版试用次数已经使用完了，如需继续使用请联系客服购买付费版。",

  // 客服标签
  wechatCustomerService: "微信客服",
};
